export const convertLiveStatus = (status) => {
    let title = "-"
    switch (status) {
        case "COMPLETED":
            title = "ໄລຟ ສໍາເລັດ"
            break;
        case "CREATED":
            title = "ສ້າງໄລຟ"
            break;
        case "CANCELLED":
            title = "ຍົກເລີກ Live"
            break;
        case "ONAIR":
            title = "ກຳລັງໄລຟ"
            break;
        case "PROCESSING":
            title = "ກຳລັງປະມວນຜົນ"
            break;
        case "WARNING":
            title = "ເກີດຂໍ້ຜິດພາດ"
            break;
        default:
            title = "ສ້າງ Live"
            break;
    }
    return title
}